import {Inject, Injectable} from '@angular/core';
import {FirebaseApp} from 'angularfire2';
import {AngularFireDatabase} from 'angularfire2/database';
import {AuthService} from './auth.service';
import {Device} from '../classes/device';
import {Partner} from '../classes/partner';
import * as firebase from 'firebase';
import {Client} from '../classes/client';
import {DeviceService} from './device.service';

@Injectable()
export class AllocService {
  private sdkDb: any;
  userId: string =  null;
  userType;
  constructor (private db: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp, private authService: AuthService,
               private deviceService: DeviceService) {
    this.sdkDb = fb.database();
    this.authService.getCurrentUser().subscribe(user => {
      if  (user) {
        this.userId = user.uid;
      } else {
        user = null;
      }
    });
    this.authService.getUserType().subscribe(type => {this.userType = type; });
  }
  allocDevice(device: Device, to: any) {
    let dataToSave = {};
    let fromRef = '';
    let toRef = '';
    console.log('device to alloc', device);
    const newDevice = new Device(device.model, device.serial, '', '' , 0 ,
      firebase.database.ServerValue.TIMESTAMP , device.key);
    device.allocatedTo = to.key;
    device.currentAllocation = firebase.database.ServerValue.TIMESTAMP;
    device.allocationCounter++;
    if (this.userType === 'admin') {
      fromRef = `devices/nuresp/${device.key}/`;
      toRef = `devices/partners/${to.key}/${device.key}/`;
    } else if (this.userType === 'partner') {
      fromRef = `devices/partners/${this.userId}/${device.key}`;
      toRef = `devices/clients/${to.key}/${device.key}`;
      dataToSave[`clientsPerPartner/${this.userId}/${to.key}/currentDevice`] = device.serial;
      dataToSave[`avaliableForConnection/${device.key}`] = {owner: this.userId, clientEmail: to.email, deviceSerial: device.serial,
        clientId: to.key};
    }
    dataToSave[fromRef] = device;
    dataToSave[toRef] = newDevice;
    return this.sdkDb.ref().update(dataToSave);
  }
  deallocDevice(device: Device) {
    let toRef;
    let allocHistoryRef;
    let deviceRef;
    let dataToSave = {};
    const pushKey = this.db.createPushId();
    const historyObject = {
      startDate: device.currentAllocation,
      endDate: firebase.database.ServerValue.TIMESTAMP,
      to: device.allocatedTo
    }
    if (this.userType === 'admin') {
      toRef = `devices/partners/${device.allocatedTo}/${device.key}`;
      allocHistoryRef = `allocHistory/nuresp/${device.key}/${pushKey}/`;
      deviceRef = `devices/nuresp/${device.key}`;

    } else if (this.userType === 'partner') {
      toRef = `devices/clients/${device.allocatedTo}/${device.key}`;
      allocHistoryRef = `allocHistory/partners/${this.userId}/${device.key}/${pushKey}/`;
      deviceRef = `devices/partners/${this.userId}/${device.key}`;
      dataToSave[`clientsPerPartner/${this.userId}/${device.allocatedTo}/currentDevice`] = null;
    }
    device.currentAllocation = 0;
    device.allocatedTo = '';
    dataToSave[toRef] = null;
    dataToSave[allocHistoryRef] = historyObject;
    dataToSave[deviceRef] = device;
    dataToSave[`avaliableForConnection/${device.key}`] = null;
    return this.sdkDb.ref().update(dataToSave);
  }
  getAllocatedTo(key: string) {
    let ref = '';
    if (this.userType === 'admin') {
      ref = `partners/${key}/name`;
    } else if (this.userType === 'partner') {
      ref = `clientsPerPartner/${this.userId}/${key}/name`;
    }
    return this.db.object(ref).valueChanges();
  }
  getAllocationCount(key: string) {
    let dbRef = '';
    if (this.userType === 'admin') {
      dbRef = `devices/nuresp`;
    } else if (this.userType === 'partner') {
      dbRef = `devices/partners`;
    }
    return this.db.list(dbRef, ref => ref.orderByChild('allocatedTo').equalTo(key)).valueChanges();
  }
  deallocFromClient(deviceKey: string) {
    return this.deviceService.getDevice(deviceKey).first().map(device => {
      console.log('device'); return this.deallocDevice(device[0]);
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/shared/services/alloc.service.ts